<template>
  <el-dialog
    title="客户信息"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="960px"
    append-to-body
    @closed="handleClosed">
    <el-form
      :inline="true"
      style="display:flex;justify-content: space-between;"
      @submit.native.prevent>
      <el-form-item>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="config.keyword"
          placeholder="请输入客户名称"
          clearable
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        :resizable="false"
        label="客户名称"
        prop="customerName"></el-table-column>
      <el-table-column
        :resizable="false"
        label="联系人"
        width="80"
        prop="contactMan"></el-table-column>
      <el-table-column
        :resizable="false"
        label="联系手机"
        width="100"
        prop="contactPhone"></el-table-column>
      <el-table-column
        :resizable="false"
        label="联系地址"
        prop="contactAddress"></el-table-column>
      <el-table-column
        width="230"
        :resizable="false"
        label="所属部门(公司)"
        prop="departmentName"></el-table-column>
      <el-table-column
        label="操作"
        width="105">
        <template slot-scope="{row}">
          <el-button
            type="info"
            @click.native="setInfo(row)">业绩设置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'WarehouseModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        keyword: ''
      },
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.total = 0
      this.config.pageNum = 1
      this.config.keyword = ''
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('vendor/getcustomers', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
